import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { selectPurchaseDetails } from '@Header/Account/ducks/selectors';
import MenuLine from '../../Shared/MenuLine';
import ReservationInProgressCard from '../../Shared/ReservationInProgressCard';

const ReservationWrapper = styled.div`
  display: flex;
  flex: 1;
  padding: 15px 20px;
`;

const ReservationTypography = styled.div`
  color: ${props => props.theme.carvana.blue.dark};
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 9px;
  text-transform: uppercase;
  white-space: nowrap;
`;

const StyledMenuLine = styled(MenuLine)`
  display: none;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    display: block;
  }
`;

const Reservation = ({ reservationStatus }) => {
  if (reservationStatus.toLowerCase() === 'reserved') {
    return (
      <Fragment>
        <ReservationWrapper>
          <div>
            <ReservationTypography>

              Reservation In Progress
            </ReservationTypography>
            <ReservationInProgressCard />
          </div>
        </ReservationWrapper>
        <StyledMenuLine />
      </Fragment>
    );
  }
  return null;
};

Reservation.defaultProps = {
  reservationStatus: ''
};

Reservation.propTypes = {
  reservationStatus: PropTypes.string
};

const mapStateToProps = state => ({
  reservationStatus: selectPurchaseDetails(state).purchaseDetails.orderState
});

export default connect(mapStateToProps)(Reservation);
